export { LoadingPlaceHolder } from './Loading.styled';
